import PropTypes from 'prop-types';
import DataGridContextProvider from '@common/components/DataGrid/DataGridContextProvider';

export default function DataGridHeader({ children }) {
  return (
    <DataGridContextProvider type="header">
      <thead>{children}</thead>
    </DataGridContextProvider>
  );
}

DataGridHeader.propTypes = {
  children: PropTypes.node,
};
